import { addDays, startOfDay } from 'date-fns';
import { EmailAgentAvailabilityWindow } from './EmailAgentAvailabilityForm.types';

export const getDaysForAvailibility = (
    startDate: Date,
    numOfDays = 6
): Array<Date> => {
    const today = startOfDay(startDate);
    const availableDays = [today];
    let elapsedDays = 1;
    while (elapsedDays < numOfDays) {
        availableDays.push(addDays(today, elapsedDays));
        elapsedDays++;
    }
    return availableDays;
};

export const getAvailabilityWindows = (): Array<EmailAgentAvailabilityWindow> => {
    return [
        { open: 8, close: 12 },
        { open: 12, close: 17 },
        { open: 17, close: 21 }
    ];
};
